<template>
  <div class="permissions-tree-panel d-flex flex-column">
    <div class="permissions-tree-panel__toolbar d-flex align-items-center flex-wrap flex-shrink-0">
      <PillTabs
        v-model="activeModuleName"
        :options="moduleOptions"
        small
      />
      <BFormInput
        v-model="search"
        icon
        size="sm"
        :placeholder="$t('permissions.searchPermissions')"
        class="permissions-tree-panel__search mr-auto"
      />
    </div>

    <div class="permissions-tree-panel__list flex-grow-1 min-height-0">
      <PermissionRow
        v-for="node in visibleNodes"
        :key="node.name"
        :node="node"
        :assigned-permissions="assignedPermissions"
        :selected="selected"
        :search="search"
        @select="$emit('select', $event)"
      />

      <div
        v-if="!visibleNodes.length"
        class="text-center text-muted py-4"
      >
        <small>{{ $t('general.noPermissions') }}</small>
      </div>
    </div>
  </div>
</template>

<script>
import PillTabs from '@core/components/PillTabs';
import permissionMatchesQuery from '@/utils/permissionsSearch';
import PermissionRow from './PermissionRow';

export default {
  name: 'PermissionsTreePanel',
  props: {
    modules: {
      type: Array,
      required: true,
    },
    assignedPermissions: {
      type: Array,
      default: () => [],
    },
    selected: String,
  },
  data() {
    return {
      activeModuleName: this.modules[0]?.name,
      search: '',
    };
  },
  components: {
    PillTabs,
    PermissionRow,
  },
  computed: {
    moduleOptions() {
      return this.modules.map(m => ({ value: m.name, text: m.text }));
    },
    activeModule() {
      return this.modules.find(m => m.name === this.activeModuleName) || this.modules[0];
    },
    visibleNodes() {
      const children = this.activeModule?.children || [];
      return children.filter(n => permissionMatchesQuery(n, this.search));
    },
  },
  watch: {
    modules() {
      if (!this.modules.some(m => m.name === this.activeModuleName)) {
        this.activeModuleName = this.modules[0]?.name;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.permissions-tree-panel__toolbar {
  gap: 8px;
  margin-bottom: 10px;
}

.permissions-tree-panel__search {
  max-width: 320px;
  width: 100%;
}

.permissions-tree-panel__list {
  overflow-y: auto;
}
</style>
